export default {
    patientIdFilter: "filter:patientId",
    patientNameFilter: "filter:patientName",
    modalityFilter: "filter:modality",
    requestTypeFilter: "filter:requestType",
}